import { render, staticRenderFns } from "./OnboardingDialog.vue?vue&type=template&id=53cc7daa&scoped=true&"
import script from "./OnboardingDialog.vue?vue&type=script&lang=js&"
export * from "./OnboardingDialog.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingDialog.vue?vue&type=style&index=0&id=53cc7daa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cc7daa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Repository/SPRAYER_MANAGER/SPRAYER_MANAGER_SITO/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VItem } from 'vuetify/lib'
import { VItemGroup } from 'vuetify/lib'
import { VResponsive } from 'vuetify/lib'
import { VWindow } from 'vuetify/lib'
import { VWindowItem } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VDialog,VIcon,VImg,VItem,VItemGroup,VResponsive,VWindow,VWindowItem})
